exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".header-bottom-area .cambio{color:#fff;font-size:14px;margin-top:16px}.header-bottom-area---Y2yBk{background-color:#022052;margin-bottom:20px}", ""]);

// exports
exports.locals = {
	"header-bottom-area": "header-bottom-area---Y2yBk"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoaders=1&modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader!./~/sass-loader!./~/sass-resources-loader/lib/loader.js!./src/app/directives/header/bar/style.scss
// module id = 359
// module chunks = 0